import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router";
import { BellOutlined } from "@ant-design/icons";
import { MailIcon } from "lucide-react";
import Badge from "@mui/material/Badge";
import axios from "axios";
import userStore from "../../zustand/store/userStore"; // Import user

const AppHeader = ({ title, content }) => {
	const navigate = useNavigate();
	const [showDropdown, setShowDropdown] = useState(false);
	const [notifications, setNotifications] = useState([]);
	const [notificationLoading, setNotificationLoading] = useState(false);
	const dropdownRef = useRef(null);

	const { user } = userStore();
	const userRole = user?.role;

	useEffect(() => {
		const fetchNotifications = async () => {
			try {
				setNotificationLoading(true);
				let res;

				if (userRole === "admin") {
					res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/getAllAnnouncement?page=1&limit=5`);
				} else {
					res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/getRoleWise?role=${userRole}&page=1&limit=5`);
				}

				setNotifications(res.data.data);
			} catch (err) {
				console.error("Error fetching notifications:", err);
			} finally {
				setNotificationLoading(false);
			}
		};

		if (showDropdown) {
			fetchNotifications();
		}
	}, [showDropdown, userRole]);

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setShowDropdown(false);
			}
		};
		document.addEventListener("mousedown", handleClickOutside);
		return () => document.removeEventListener("mousedown", handleClickOutside);
	}, []);

	return (
		<div className="pb-5 flex flex-col sm:flex-row sm:justify-between sm:items-center px-4">
			<div className="sm:text-left mb-4 sm:mb-0">
				<div className="text-xl font-semibold text-gray-800">{title}</div>
				<div className="text-sm text-gray-600">{content}</div>
			</div>

			<div className="flex items-center mt-4 sm:mt-0 sm:ml-4">
				{/* <div className="relative w-full sm:max-w-xs">
					<span className="absolute inset-y-0 right-0 flex items-center px-3 text-gray-500">
						<SearchOutlined />
					</span>
					<input
						type="text"
						className="px-5 p-2 rounded-lg w-full border-2 border-solid border-black"
						placeholder="Search from courses..."
					/>
				</div> */}
				<div className="relative ml-4 mr-6">
					<Badge
						variant="dot"
						color="error"
						onClick={() => setShowDropdown(!showDropdown)}
						className="cursor-pointer"
					>
						<BellOutlined style={{ fontSize: 28, cursor: "pointer" }} />
					</Badge>
					{showDropdown && (
						<div className="absolute right-0 mt-2 w-80 bg-white rounded-xl shadow-xl border border-gray-100 z-20 max-h-96 overflow-y-auto">
							<div className="p-4">
								<h3 className="text-lg font-semibold text-gray-800">Notifications</h3>
								{notificationLoading ? (
									<div className="flex justify-center py-4">
										<div className="animate-spin rounded-full h-8 w-8 border-2 border-blue-500 border-t-transparent"></div>
									</div>
								) : notifications.length === 0 ? (
									<p className="text-gray-500 py-4 text-center">No new notifications</p>
								) : (
									notifications.map((notification, index) => (
										<div
											key={index}
											className="p-3 hover:bg-gray-50 rounded-lg cursor-pointer transition-colors duration-200"
											onClick={() => {
												setShowDropdown(false);
												navigate("/notification");
											}}
										>
											<h4 className="text-sm font-medium text-gray-800">
												{notification.title}
											</h4>
											<p className="text-xs text-gray-500 truncate">
												{notification.message}
											</p>
											<span className="text-xs text-gray-400">
												{new Date(notification.createdAt).toLocaleString("en-US", {
													year: "numeric",
													month: "short",
													day: "numeric",
													hour: "numeric",
													minute: "2-digit",
													hour12: true,
												})}
											</span>
										</div>
									))
								)}
							</div>
						</div>
					)}
				</div>
				<Badge
					variant="dot"
					color="error"
					className="mt-1 cursor-pointer"
					onClick={() => navigate("/messages")}
				>
					<MailIcon style={{ fontSize: 28, cursor: "pointer" }} />
				</Badge>
			</div>
		</div>
	);
};

export default AppHeader;
